import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrash, faSearch } from '@fortawesome/free-solid-svg-icons';
import BlogServices from '../services/BlogServices'; 
import HelpTogal from './TogelButton/TogleButtonForStatus';
import Modal from 'react-modal';
import UpdateBlog from '../component/Update Model/UpdateBlog';
import DeleteButton from './Button/DeleteButton';
import Pagetitle from './PageTitle';
import useAsync from '../hooks/useAsync';

Modal.setAppElement('#root');

function Blog() {
  const { data,  run } = useAsync(BlogServices.getBlogs);
  const [blogs, setBlogs] = useState([]);
  const [activeIndex, setActiveIndex] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState(null);
  const [temp, setTemp] = useState(0);

  // Pagination states
  const [currentPage, setCurrentPage] = useState(1);
  const blogsPerPage = 7;

  useEffect(() => {
    async function fetchBlogs() {
      try {
        const response = await BlogServices.getBlogs();
        const sortedBlogs = (response.data?.data || response.data || []).sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );
        setBlogs(sortedBlogs);
      } catch (err) {
        setError(err);
      } finally {
        setIsLoading(false);
      }
    }
    fetchBlogs();
  }, []);

  const filteredBlogs = blogs.filter(blog =>
    blog.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const handleSearch = (e) => setSearchQuery(e.target.value);

  // Pagination logic
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  const totalPages = Math.ceil(filteredBlogs.length / blogsPerPage);

  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  const handleDelete = (blog) => {
    setSelectedEdit(blog);
    setIsDeleteModalOpen(true);
    toggleActionMenu(null);
  };

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false);
    setSelectedEdit(null);
  };
  const handleDeleteSuccess = () => {
    // Update the blogs state to remove the deleted blog
    setBlogs(prevBlogs => prevBlogs.filter(item => item._id !== selectedEdit._id));
    closeDeleteModal();
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index); // Toggle the active index
  };
  if (isLoading) return <div>Loading blogs...</div>;
  if (error) return <div>Error loading blogs. Please try again later.</div>;
  
  function truncateText(text, limit) {
    const words = text.split(' ');
    if (words.length > limit) {
      return words.slice(0, limit).join(' ') + '...';
    }
    return text;
  }
  
  return (
    <div className="right_col" role="main">
      <Pagetitle />
      <div className="container-box px-0">
        <div className="container-box-top-header justify-content-between">
         <div className="container-box-top-header-left-2">
                       <input
                         type="search"
                         name="search"
                         placeholder="Search"
                         value={searchQuery}
                         onChange={handleSearch}
                       />
                       <button className="search-btn"><FontAwesomeIcon icon={faSearch} /></button>
                     </div>
           <div className="container-box-top-header justify-content-end">
                        <div className="sub-title-box-right">
                          <Link className="Add-new-btn site-btn-green" style={{ backgroundColor: "#FF7029" }} to="/admin/add-blog">
                            <img src="img/plus-circle.svg" className='me-2' alt='' />Add New
                          </Link>
                        </div>
                      </div>
        </div>

        <div className="container-box-inner">
          <table id="example" className="table table-striped" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>#</th>
                <th>BLOG IMAGE</th>
                <th>TITLE</th>
                <th>AUTHOR</th>
                <th>CONTENT</th>
                <th>CREATE DATE</th>
                <th>STATUS</th>
                <th>EDIT</th>
                <th>DELETE</th>
              </tr>
            </thead>
            <tbody>
              {currentBlogs.map((blog, i) => (
                <tr key={blog._id}>
                  <td>{indexOfFirstBlog + i + 1}</td>
                  <td>
                    <img 
                      src={process.env.REACT_APP_URL + blog?.images[0]} 
                      alt={blog.title || "Blog"} 
                      style={{ height: '70px', width: '70px', objectFit: 'contain' }} 
                    />
                  </td>
                  <td>{blog.title}</td>
                  <td>{blog.author}</td>
                  <td>
  <div dangerouslySetInnerHTML={{ __html: truncateText(blog.content, 20) }} />
</td>

                  <td>{new Date(blog.createdAt).toLocaleDateString()}</td>
                  <td className="status-toggle">
                    <HelpTogal data={blog} page='Blog' onSuccess={() => run()} />
                  </td>
                  <td>
                    <button 
                      className="view-details-btn edit-btn" 
                      onClick={() => { setSelectedEdit(blog); setIsEditModalOpen(true); }}
                    >
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  </td>
                  <td>
                    <button 
                      className="view-details-btn delete-btn" 
                      onClick={() => handleDelete(blog)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination Controls */}
        <div className="pagination">
          <button 
            onClick={() => handlePageChange(currentPage - 1)} 
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            Previous
          </button>

          {[...Array(totalPages).keys()].map((number) => (
            <button 
              key={number + 1} 
              onClick={() => handlePageChange(number + 1)}
              className={`pagination-btn ${currentPage === number + 1 ? 'active' : ''}`}
            >
              {number + 1}
            </button>
          ))}

          <button 
            onClick={() => handlePageChange(currentPage + 1)} 
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            Next
          </button>
        </div>
      </div>

      {/* Edit Blog Modal */}
      <Modal isOpen={isEditModalOpen} onRequestClose={() => setIsEditModalOpen(false)} className="modal-content" overlayClassName="modal-overlay">
        <UpdateBlog blog={selectedEdit} closeModal={() => setIsEditModalOpen(false)} onSuccess={() => window.location.reload()} />
      </Modal>
      
      {/* Delete Confirmation Modal */}
      <Modal
          isOpen={isDeleteModalOpen}
          onRequestClose={closeDeleteModal}
          contentLabel="Delete Confirmation"
          className="modal-content"
          overlayClassName="modal-overlay"
        >
          <DeleteButton data={selectedEdit} page="Blog" closeModal={closeDeleteModal}  onSuccess={handleDeleteSuccess}/>
        </Modal>
    </div>
  );
}

export default Blog;
